const isMaintenanceMode = false;
const queryParam = 'qatest'; // to allow testing
const endDate = '2025-06-10';
const endTime = '17:00';
const maintenanceEmail = 'events@workforcegps.org';
export { isMaintenanceMode, queryParam, endDate, endTime, maintenanceEmail }; 